import { ChangeDetectorRef, Component, HostListener, Inject, OnInit, ViewChild, ElementRef, ViewRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileUploaderService } from '@app-services/file-uploader.service';
import * as moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';
import { EvaluationService } from '@app-services/evaluation.service';
import { remove } from 'lodash';
import { OemDealerService } from '@app-services/oem-dealer.service';

@Component({
  selector: 'app-dialog-upload-audio-report-item',
  templateUrl: './dialog-upload-audio-report-item.component.html',
  styleUrls: ['./dialog-upload-audio-report-item.component.scss']
})
export class DialogUploadAudioReportItemComponent implements OnInit {

  title: string;
  vehicleId: string;
  
  onlyView: boolean;
  
  waitingPermission = true;
  permissionDenied = false;
  recording = false;
  audioURL: any;
  blob: Blob;
  savedAudio = false;
  currentTime: any;
  currentTimeDate: Date;
  intervalTimer: any;
  duration: number;
  recorder: any;
  serviceType: 'evaluation' | 'oem';
  equipmentKey: string;

  @ViewChild('audioFileInput') audioFileInputRef: ElementRef<HTMLInputElement>;

  constructor(
    private readonly dialogRef: MatDialogRef<DialogUploadAudioReportItemComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly evaluationService: EvaluationService,
    private readonly oemDealerService: OemDealerService,
    private readonly ref: ChangeDetectorRef,
    private readonly sanitizer: DomSanitizer,
  ) {
    this.title = data.title;
    this.vehicleId = data.vehicleId;
    this.onlyView = data.onlyView;
    if(data.audio){
      this.audioURL = data.audio.url;
      this.savedAudio = true;
    }

  }

  ngOnInit() {
  }

  @HostListener('window:keyup.esc')
  onNoClick(): void {
    this.dialogRef.close();
  }

  saveAudioAndClose(): void {
    const key = this.data.equipmentKey;
    
    const call$ = this.data.serviceType === 'oem'
      ? this.oemDealerService.saveMedia(this.blob, this.data.vehicleId, key)
      : this.evaluationService.saveMedia(this.blob, this.data.vehicleId, key);

    call$.subscribe(res => {
      if (res.success) {
        this.savedAudio = true;
        this.dialogRef.close({ url: res.url, duration: this.duration });
      }
    });
  }


  removeItem() {
    if(this.savedAudio){
      this.dialogRef.close({remove: true});
    }
    this.audioURL = '';
    this.savedAudio = false;
  }

  async startRecording(): Promise<void> {
    this.waitingPermission = true;
    this.audioURL = '';
    const MicRecorder = (await import('mic-recorder-to-mp3')).default;
    this.recorder = new MicRecorder({ bitRate: 320 });

    this.recorder.start().then(() => {
      this.initCurrentTimeRecorder();
      this.recording = true;

      this.waitingPermission = false;
      this.permissionDenied = false;
      this.ref.detectChanges();
    })
      .catch((e) => {
        alert('Error starting recording');
      });
  }

  stopRecording(): void {
    this.recorder
      .stop()
      .getMp3().then(([buffer, blob]) => {
        this.blob = blob;
        const blobURL = URL.createObjectURL(this.blob);

        this.audioURL = this.sanitizer.bypassSecurityTrustUrl(blobURL);
        this.recording = false;
        this.recorder = undefined;
        this.ref.detectChanges();
        this.duration = this.currentTimeDate.getSeconds();

        clearInterval(this.intervalTimer);

      });
  }

  initCurrentTimeRecorder(): void {
    this.currentTime = moment();
    this.currentTime.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    this.intervalTimer = setInterval(() => {
      this.addSecond();
      if (this.ref && !(this.ref as ViewRef).destroyed) {
        this.ref.detectChanges();
      }
    }, 1000);
  }

  addSecond(): void {
    this.currentTime.add(1, 'second');
    this.currentTimeDate = this.currentTime.toDate();
  }

  onAudioFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];
    if (!file || !file.type.startsWith('audio/')) {
      return;
    }
    input.value = '';
    this.setAudioFromFile(file);
  }

  onFileDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const file = event.dataTransfer?.files?.[0];
    if (!file || !file.type.startsWith('audio/')) {
      return;
    }
    this.setAudioFromFile(file);
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  openFileSelector(): void {
    this.audioFileInputRef?.nativeElement?.click();
  }

  private setAudioFromFile(file: File): void {
    this.blob = file;
    this.audioURL = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file));
    const audio = new Audio();
    audio.src = URL.createObjectURL(file);
    audio.onloadedmetadata = () => {
      this.duration = Math.round(audio.duration);
      URL.revokeObjectURL(audio.src);
      this.ref.detectChanges();
    };
    audio.load();
    this.ref.detectChanges();
  }

}
